var _rect, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _rect7, _rect8, _rect9, _rect0, _line2, _rect1, _rect10, _rect11, _rect12, _rect13, _line3, _rect14, _rect15, _rect16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 817,
    height: 233,
    viewBox: "0 0 817 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 133.906,
    width: 260,
    height: 100,
    rx: 8,
    transform: "rotate(-18.3621 0 133.906)",
    fill: "#1A1A1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.632053,
    y: 134.223,
    width: 259,
    height: 99,
    rx: 7.5,
    transform: "rotate(-18.3621 0.632053 134.223)",
    stroke: "white",
    strokeOpacity: 0.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2257,
    y: 144.051,
    width: 180,
    height: 10,
    rx: 5,
    transform: "rotate(-18.3621 20.2257 144.051)",
    fill: "#242424"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1965,
    y: 180.116,
    width: 130,
    height: 8,
    rx: 4,
    transform: "rotate(-18.3621 32.1965 180.116)",
    fill: "#242424"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4969,
    y: 199.098,
    width: 95,
    height: 8,
    rx: 4,
    transform: "rotate(-18.3621 38.4969 199.098)",
    fill: "#242424"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.8133,
    y1: 169.497,
    x2: 258.575,
    y2: 87.5911,
    stroke: "white",
    strokeOpacity: 0.03
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 28.5928,
    width: 260,
    height: 100,
    rx: 8,
    transform: "rotate(-0.13065 278 28.5928)",
    fill: "#1A1A1A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 278.501,
    y: 29.0916,
    width: 259,
    height: 99,
    rx: 7.5,
    transform: "rotate(-0.13065 278.501 29.0916)",
    stroke: "white",
    strokeOpacity: 0.02
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 294.036,
    y: 44.5562,
    width: 180,
    height: 10,
    rx: 5,
    transform: "rotate(-0.13065 294.036 44.5562)",
    fill: "#242424"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 294.123,
    y: 82.5562,
    width: 130,
    height: 8,
    rx: 4,
    transform: "rotate(-0.13065 294.123 82.5562)",
    fill: "#242424"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 294.169,
    y: 102.556,
    width: 95,
    height: 8,
    rx: 4,
    transform: "rotate(-0.13065 294.169 102.556)",
    fill: "#242424"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 278.085,
    y1: 66.0928,
    x2: 538.085,
    y2: 65.4999,
    stroke: "white",
    strokeOpacity: 0.03
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 569.482,
    y: 56,
    width: 260,
    height: 100,
    rx: 8,
    transform: "rotate(18.3497 569.482 56)",
    fill: "#1A1A1A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 569.799,
    y: 56.632,
    width: 259,
    height: 99,
    rx: 7.5,
    transform: "rotate(18.3497 569.799 56.632)",
    stroke: "white",
    strokeOpacity: 0.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 579.631,
    y: 76.2236,
    width: 180,
    height: 10,
    rx: 5,
    transform: "rotate(18.3497 579.631 76.2236)",
    fill: "#242424"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 567.668,
    y: 112.292,
    width: 130,
    height: 8,
    rx: 4,
    transform: "rotate(18.3497 567.668 112.292)",
    fill: "#242424"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 561.372,
    y: 131.274,
    width: 95,
    height: 8,
    rx: 4,
    transform: "rotate(18.3497 561.372 131.274)",
    fill: "#242424"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 557.676,
    y1: 91.5933,
    x2: 804.456,
    y2: 173.445,
    stroke: "white",
    strokeOpacity: 0.03
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 272.33,
    y: 28.0972,
    width: 20,
    height: 4,
    rx: 2,
    transform: "rotate(-135.162 272.33 28.0972)",
    fill: "white",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 254.061,
    y: 30.5693,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-4.72994 254.061 30.5693)",
    fill: "white",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 279.474,
    y: 7.36816,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(86.5404 279.474 7.36816)",
    fill: "white",
    fillOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOrder);
export default __webpack_public_path__ + "static/media/no-order.b97d9678.svg";
export { ForwardRef as ReactComponent };